var betaMsg = function () {
    if (Modernizr.mq('only all')) {

        // Move Beta Messge to different position for mobile
        var movebetaMsg = function() {
            $('[data-id="betamsg-banner"]').prependTo('[data-id="mobile-beta-location"]');
        };

        // Move it back for Desktop
        var movebetaMsgBack = function() {
            $('[data-id="betamsg-banner"]').insertAfter('ul.accessmenu');
        };

        enquire.register("screen and (max-width:47.938em)", {
            match: function () {
                movebetaMsg();

            },
            unmatch: function () {
                movebetaMsgBack();
            }
        }, true);
    }
}